import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b391be6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "basic-info" }
const _hoisted_2 = { class: "form-block" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-head df aic" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title-block" }),
  /*#__PURE__*/_createElementVNode("span", { class: "info-head-title" }, "基本信息")
], -1))
const _hoisted_4 = { class: "form-item-block" }
const _hoisted_5 = {
  class: "df",
  style: {"width":"100%"}
}
const _hoisted_6 = {
  class: "df aic",
  style: {"width":"200px","flex-direction":"column"}
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("编辑头像")
const _hoisted_8 = { class: "form-head-right df jcsb" }
const _hoisted_9 = { class: "form-head-block" }
const _hoisted_10 = { class: "form-head-block" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("男")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("女")
const _hoisted_13 = { class: "df jscb" }
const _hoisted_14 = { style: {"text-align":"right","margin":"10px 0 20px"} }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("保存")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_form, {
          "label-position": "top",
          "label-width": "110px",
          ref: "ruleFormRef",
          model: _ctx.form,
          inline: true,
          rules: _ctx.rules
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_avatar, {
                  size: 120,
                  src: _ctx.avatar,
                  fit: "fill"
                }, null, 8, ["src"]),
                _createVNode(_component_el_upload, {
                  ref: "uploadRef",
                  class: "upload-btn",
                  action: _ctx.action,
                  accept: ".png,.jpg",
                  "show-file-list": false,
                  "on-success": _ctx.handleSuccess
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["action", "on-success"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_el_form_item, {
                    label: "姓名",
                    prop: "accountName"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        required: "",
                        modelValue: _ctx.form.accountName,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.accountName) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "求职状态",
                    prop: "jobStatus"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        style: {"width":"100%"},
                        modelValue: _ctx.form.jobStatus,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.jobStatus) = $event)),
                        placeholder: "请选择求职状态"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.text,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_el_form_item, {
                    label: "性别",
                    prop: "sex"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: _ctx.form.sex,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.sex) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio, { label: 1 }, {
                            default: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, { label: 0 }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_el_form_item, {
                      style: {"width":"60%"},
                      label: "出生日期",
                      prop: "birthTime"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.form.birthTime,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.birthTime) = $event)),
                          type: "date",
                          required: "",
                          placeholder: "请选择出生日期",
                          style: {"width":"100%"},
                          format: "YYYY-MM-DD",
                          "value-format": "YYYY-MM-DD"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      style: {"width":"40%"},
                      label: "年龄",
                      prop: "age"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          disabled: "",
                          modelValue: _ctx.form.age,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.age) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createVNode(_component_el_form_item, {
              label: "身份证号",
              prop: "idCard"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.idCard,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.idCard) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "邮箱",
              prop: "email"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.email,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.email) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "参加工作时间",
              prop: "startWorkDate"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.form.startWorkDate,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.startWorkDate) = $event)),
                  type: "date",
                  required: "",
                  placeholder: "请选择参加工作时间",
                  style: {"width":"100%"},
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "最近工作单位",
              prop: "lastWorkUnit"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  required: "",
                  modelValue: _ctx.form.lastWorkUnit,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.lastWorkUnit) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "手机号",
              prop: "mobile"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  required: "",
                  modelValue: _ctx.form.mobile,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.mobile) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "微信号",
              prop: "weChat"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.weChat,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.weChat) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "户口所在地",
              prop: "hukouCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_cascader, {
                  style: {"width":"100%"},
                  modelValue: _ctx.form.hukouCode,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.hukouCode) = $event)),
                  options: _ctx.cityOptions,
                  props: _ctx.cascaderProps,
                  filterable: "",
                  ref: "hukouAddr"
                }, null, 8, ["modelValue", "options", "props"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "现居地址",
              prop: "currentCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_cascader, {
                  style: {"width":"100%"},
                  modelValue: _ctx.form.currentCode,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.currentCode) = $event)),
                  options: _ctx.cityOptions,
                  props: _ctx.cascaderProps,
                  filterable: "",
                  ref: "currentAddr"
                }, null, 8, ["modelValue", "options", "props"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              style: {"width":"100%"},
              label: "自我评价",
              prop: "selfEvaluate"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("textarea", {
                  class: "el-textarea__inner content-textarea",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.selfEvaluate) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.form.selfEvaluate]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _createElementVNode("div", _hoisted_14, [
          (!_ctx.isBatch)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: "submit-btn",
                icon: _ctx.Close,
                type: "primary",
                plain: "",
                onClick: _ctx.closeDialog
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }, 8, ["icon", "onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            class: "submit-btn",
            type: "primary",
            icon: _ctx.Check,
            loading: _ctx.isLoading,
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef)))
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }, 8, ["icon", "loading"])
        ])
      ])
    ])
  ]))
}